import React, {Fragment} from 'react';
import createEditor from '../form/ComponentEditor';
import Box from '../layout/Box';
import {SelectButton} from 'primereact/selectbutton';
import LocationEditor from "./locationEditor";
import Modal from "../layout/Modal";
import classNames from "classnames";
import PartnerForm from "./forms/partnerForm";
import PartnerList from "./lists/partnerList";
import ModalEditor from "./ModalEditor";
import BoxEditor from "./BoxEditor";
import Button from "../form/Button";
import CommercialContractEditor from "./CommercialContractEditor";
import {connect} from "src/store";
import {PartnerCommercialContractForm} from "./forms/CommercialContractForm";
import BankAccountEditor from "./BankAccountEditor";
import ComponentConfig from "../form/ComponentConfig";

class partnerEditor extends React.Component {

    state = {
        partner_type: ['company', 'user'],
    };

    newPartner = async () => {
        await this.props.pristineForm();
        this.modal.show();
    }

    saveForm = async (event) => {
        await this.props.saveForm(event);
        this.list && this.list.refresh();
    }

    render() {

        const List = this.props.list || Box;
        const Editor = this.props.editor || BoxEditor;

        const filter = [];
        const partner_types = [
            {label: 'Cég', value: 'company'},
            {label: 'Magánszemély', value: 'user'}
        ];
        filter.push({
            field: "component_type", value: this.state.partner_type, operator: 'in'
        });
        const newbutton = <Button
            type="button"
            disabled={this.props.isLoading}
            color="default"
            className="pull-left"
            onClick={this.newPartner}
        >
            Új
        </Button>;
        const actions = <Fragment>
            <Button
                disabled={!this.props.dirty || this.props.isLoading}
                color="primary"
                className="pull-right"
                onClick={this.saveForm}
            >
                Mentés
            </Button>
            <Button
                disabled={!this.props.values.partner_id || this.props.isLoading}
                color="warning"
                className="pull-right"
                onClick={this.props.deleteForm}
            >
                Törlés
            </Button>
        </Fragment>;
        return (
            <Fragment>
                <Modal
                    ref={(el) => this.modal = el}
                    type="default"
                    header="Új partner felvétele"
                    buttons={[
                        {
                            text: 'Cég',
                            onClick: async () => {
                                const values = {...this.props.values, component_type: 'company', [this.props.componentConfig.idfield]: null};
                                await this.props.setInitialValues(values);
                                await this.props.setFormValues(values);
                                this.modal.hide();
                                this.editor.focus();
                            }
                        },
                        {
                            text: 'Magánszemély',
                            onClick: async () => {
                                const values = {...this.props.values, component_type: 'user', [this.props.componentConfig.idfield]: null};
                                await this.props.setInitialValues(values);
                                await this.props.setFormValues(values);
                                this.modal.hide();
                                this.editor.focus();
                            }
                        },
                        {
                            text: 'Mégse',
                            onClose: true,
                            onClick: () => {
                                this.modal.hide();
                            }
                        }
                    ]}
                >
                    Milyen típusú partnert szeretnél felvenni?
                </Modal>
                <List
                    {...this.props}
                    theme="default"
                    header={"Partner lista"}
                    actions={<SelectButton value={this.state.partner_type} multiple={true} options={partner_types}
                                           onChange={(e) => this.setState({partner_type: e.value})}/>}
                    footer={newbutton}
                >
                    <PartnerList ref={(el) => this.list = el} {...this.props} filter={filter}/>
                </List>
                {this.props.values.component_type &&
                    <Fragment>
                        <Editor
                            ref={(el) => this.editor = el}
                            {...this.props}
                            theme="default"
                            header={"Partner törzsadatok"}
                            collapsed={this.props.collapsed || false}
                            footer={actions}
                        >
                            <PartnerForm {...this.props} />
                        </Editor>
                        {
                            (this.props.inline === undefined || this.props.inline === false) && this.props.values[this.props.componentConfig.idfield] &&
                            <LocationEditor
                                gridid={"partnerEditorLocationList"}
                                presets={{partner: this.props.values}}
                                isLoading={this.props.isLoading}
                                editor={ModalEditor}
                                selection={null}
                                listFilter={[
                                    {
                                        field: "partner",
                                        value: this.props.values[this.props.componentConfig.idfield]
                                    }
                                ]}
                            />
                        }
                        {
                            this.props.pos && (this.props.inline === undefined || this.props.inline === false) && this.props.values[this.props.componentConfig.idfield] &&
                            <CommercialContractEditor
                                editorContext="CommercialContractSeller"
                                header="Vevői kedvezmények"
                                gridid={"partnerEditorCommercialContractCustomerList"}
                                presets={{seller: this.props.pos.partner[this.props.componentConfig.idfield], customer: this.props.values[this.props.componentConfig.idfield]}}
                                isLoading={this.props.isLoading}
                                list={()=><div/>}
                                selection={null}
                                filter={[
                                    {
                                        field: "seller",
                                        value: this.props.pos.partner[this.props.componentConfig.idfield]
                                    },
                                    {
                                        field: "customer",
                                        value: this.props.values[this.props.componentConfig.idfield]
                                    }
                                ]}
                                formType={PartnerCommercialContractForm}
                            />
                        }
                        {
                            this.props.pos && (this.props.inline === undefined || this.props.inline === false) && this.props.values[this.props.componentConfig.idfield] &&
                            <CommercialContractEditor
                                editorContext="CommercialContractCustomer"
                                header="Eladói kedvezmények"
                                gridid={"partnerEditorCommercialContractSellerList"}
                                presets={{seller: this.props.values[this.props.componentConfig.idfield], customer: this.props.pos.partner[this.props.componentConfig.idfield]}}
                                isLoading={this.props.isLoading}
                                list={() => null}
                                selection={null}
                                filter={[
                                    {
                                        field: "seller",
                                        value: this.props.values[this.props.componentConfig.idfield]
                                    },
                                    {
                                        field: "customer",
                                        value: this.props.pos.partner[this.props.componentConfig.idfield]
                                    }
                                ]}
                                formType={PartnerCommercialContractForm}
                            />
                        }
                    </Fragment>
                }
            </Fragment>
        );
    }
}

export default connect((state) => {
    return {
        pos: state.app.till.pos
    };
}, {})(createEditor({componentName: "partner", WrappedComponent: partnerEditor}));
